export const PACKGO_INTRO_ROUTE = 'packgo.intro'
export const PACKGO_INTRO_WELCOME_ROUTE = 'packgo.intro.welcome'
export const PACKGO_INTRO_WORKFLOWS_ROUTE = 'packgo.intro.workflows'
export const PACKGO_CONNECT_ROUTE = 'packgo.connect'
export const PACKGO_QUEUE_ROUTE = 'packgo.queue'
export const NEW_PACKGO_INTRO_ROUTE = 'new-packgo.intro'
export const NEW_PACKGO_INTRO_WELCOME_ROUTE = 'new-packgo.intro.welcome'
export const NEW_PACKGO_INTRO_DOWNLOAD_ROUTE = 'new-packgo.intro.download'
export const NEW_PACKGO_INTRO_SETTINGS_ROUTE = 'new-packgo.intro.settings'
export const NEW_PACKGO_QUEUE_ROUTE = 'new-packgo.queue'
export const NEW_PACKGO_BROWSER_NOT_SUPPORTED = 'new-packgo.browser-not-supported'
export const NEW_PACKGO_PRINT_CLIENT_NOT_INSTALLED = 'new-packgo.print-client-not-installed'
